/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Icon, Text, Button } from '@components/atoms'
import Dropzone, { DropzoneState, Accept } from 'react-dropzone'

import { grey } from '@mui/material/colors'
import { FileType } from '@schemas'

interface PropsType {
	onFileChange: (aFile: File) => void
	onFileDropEnd: () => void
	showOpenFileBrowser?: boolean
	onCloseFileBrowser?: () => void
	children?: JSX.Element
	accept?: Accept
}

export const FlieDropzone = (props: PropsType) => {
	const dropzoneRef = React.createRef<any>()

	React.useEffect(() => {
		if (props.showOpenFileBrowser !== undefined && props.showOpenFileBrowser) {
			dropzoneRef.current.open()
		}
	}, [props.showOpenFileBrowser])

	const onDrop = React.useCallback((acceptedFiles: DropzoneState['acceptedFiles']) => {
		acceptedFiles.map((aFile: File) => {
			const reader = new FileReader()
			reader.readAsDataURL(aFile)

			reader.onload = () => {
				const newTempFile = {
					name: aFile.name,
					size: aFile.size,
					data:
						typeof reader.result === 'string' ? reader.result.split(';base64,')[1] : '',
				}

				props.onFileChange(aFile)
			}
		})

		onCloseFilebrowser()
		props.onFileDropEnd()
	}, [])

	const onCloseFilebrowser = () => {
		if (props.onCloseFileBrowser) {
			props.onCloseFileBrowser()
		}
	}

	return (
		<View css={style}>
			<Dropzone
				ref={dropzoneRef}
				onDrop={onDrop}
				onFileDialogCancel={onCloseFilebrowser}
				accept={
					props.accept ?? {
						'image/jpeg': ['.jpeg', '.jpg'],
						'image/png': ['.png'],
						'image/bmp': ['.bmp'],
						'image/gif': ['.gif'],
						'video/mp4': ['.mp4'],
						'video/mpeg': ['.mpeg'],
						'video/webm': ['.webm'],
						'video/quicktime': ['.mov'],
						'video/x-msvideo': ['.avi'],
						'text/plain': ['.txt'],
						'text/csv': ['.csv'],
						'application/vnd.ms-excel': ['.xls', '.xlsx'],
						'application/msword': ['.doc', '.docx'],
						'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
						'application/pdf': ['.pdf'],
					}
				}
			>
				{({ getRootProps, getInputProps }) => (
					<View className="dropzoneView">
						<input {...getInputProps()} />
						{props.children !== undefined ? (
							props.children
						) : (
							<View className="dropzoneOuterView">
								<View {...getRootProps({ className: 'importView dropzone' })}>
									<Icon className="fileUploadIcon" name="file-upload-outline" />
									<Text hint="500">
										{"'파일 불러오기' 버튼을 클릭 또는 여기로 파일을 끌어오세요."}
									</Text>

									<Button
										color="inherit"
										variant="contained"
										className="fileUploadButton"
									>
										파일 불러오기
									</Button>
								</View>
							</View>
						)}
					</View>
				)}
			</Dropzone>
		</View>
	)
}

const style = css({
	'.dropzoneOuterView': {
		paddingTop: '1rem',
		textAlign: 'right',

		'.importView': {
			position: 'relative',
			height: '100%',
			paddingTop: '1rem',
			border: '1px solid',
			borderColor: grey[300],
			borderRadius: '8px',
			textAlign: 'center',

			'.fileUploadIcon': {
				fontSize: 120,
				color: grey[300],
			},

			'.fileUploadButton': {
				marginBottom: '2rem',
			},
		},
	},
})
